import Pagination from 'tui-pagination';
export const paginationContainer = document.getElementById('tui-pagination-container');


// export const options = {
//     totalItems: totalCount,
//       itemsPerPage: itemsPerPage,
//       visiblePages: 5,
//       page: page,
//       centerAlign: true,
//   };
export const pagination = new Pagination(paginationContainer);


